import type { Timeframe } from '../types';

export interface ReplayAuthState {
  isAuthLoaded: boolean;
  isSignedIn: boolean;
}

export interface ReplayAuthActions {
  openSignIn: (options?: { returnUrl?: string }) => void;
}

const PENDING_REPLAY_ENTER_KEY = 'tradevision_pending_replay_enter_v1';
const PENDING_REPLAY_CONTEXT_KEY = 'tradevision_pending_replay_context_v1';

export interface PendingReplayContext {
  ticker?: string;
  timeframe?: Timeframe;
}

export const replayAuthService = {
  setPendingReplayEnter(context?: PendingReplayContext): void {
    try {
      localStorage.setItem(PENDING_REPLAY_ENTER_KEY, '1');
      if (context) {
        localStorage.setItem(PENDING_REPLAY_CONTEXT_KEY, JSON.stringify(context));
      }
    } catch {
      // ignore
    }
  },

  clearPendingReplayEnter(): void {
    try {
      localStorage.removeItem(PENDING_REPLAY_ENTER_KEY);
      localStorage.removeItem(PENDING_REPLAY_CONTEXT_KEY);
    } catch {
      // ignore
    }
  },

  getPendingReplayContext(): PendingReplayContext | null {
    try {
      const raw = localStorage.getItem(PENDING_REPLAY_CONTEXT_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw) as PendingReplayContext;
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch {
      return null;
    }
  },

  shouldEnterReplayAfterAuth(): boolean {
    try {
      return localStorage.getItem(PENDING_REPLAY_ENTER_KEY) === '1';
    } catch {
      return false;
    }
  },

  /**
   * Returns true if user can proceed into replay now.
   * If false, it will trigger sign-in (if possible) and set a pending replay intent.
   */
  ensureSignedInForReplay(
    state: ReplayAuthState,
    actions: ReplayAuthActions,
    context?: PendingReplayContext,
    signInOptions?: { returnUrl?: string }
  ): boolean {
    if (!state.isAuthLoaded) {
      this.setPendingReplayEnter(context);
      return false;
    }

    if (state.isSignedIn) return true;

    this.setPendingReplayEnter(context);
    actions.openSignIn(signInOptions);
    return false;
  },
};
